import React from "react";
import { Flex, Text } from "@jsq/ds/core";

type ReviewTextKeyProps = {
  keyText: string;
  valueText?: string | JSX.Element;
};

export const ReviewRow: React.FC<ReviewTextKeyProps> = ({
  keyText,
  valueText,
}: ReviewTextKeyProps) => {
  return (
    <Flex>
      <Flex flexDirection={"column"} flexGrow={0} flexShrink={0} flexBasis={210}>
        <Text variant={"secondary-md"}>{keyText}</Text>
      </Flex>
      <Flex flexDirection={"column"} flexWrap={"wrap"}>
        <Text variant={"regular-md"}>{valueText}</Text>
      </Flex>
    </Flex>
  );
};
